import { api } from "./config";

// Filterable, paginated package list for the bulk-move selection grid.
// No route-navigator eligibility filtering — any package is a candidate;
// the target station is restricted to each package's route at move time.
export async function GetBulkMoveList(filters = {}) {
  try {
    const response = await api().get("/package-bulk-move/list", { params: filters });
    return response.data;
  } catch (error) {
    return {
      success: false,
      data: [],
      total: 0,
      message: error?.response?.data?.message || error.message,
    };
  }
}

// Groups the selected packages by route, each group with the stations it may
// move to (its route's stations, STD/END included, in route order).
export async function GetBulkMoveRouteGroups(packageIds) {
  try {
    const response = await api().post("/package-bulk-move/route-groups", { packageIds });
    return response.data;
  } catch (error) {
    return {
      success: false,
      groups: [],
      message: error?.response?.data?.message || error.message,
    };
  }
}

// Moves packages to stations on their own route (forward or backward — route
// order not enforced), fragile-check/Fanshine gates bypassed. Manager-only tool.
// `moves` is [{ targetStationId, packageIds }], one entry per route group.
// `remark` (min 10 chars, enforced server-side) is required and gets
// appended to each package's existing remark, on a new line.
export async function BulkMoveToStation(moves, remark) {
  try {
    const response = await api().post("/package-bulk-move/move", {
      moves,
      remark,
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error.message,
      skipped: error?.response?.data?.skipped,
    };
  }
}
